import {t} from "../i18n";
import {BrandButton} from "../ui/buttons/buttons";
import * as React from "react";
import {SubmissionError} from "./UserDetailsFormStep";

export const SubmitOrNextButton = (props: { allValid: boolean, nrOfSteps: number, stepIndex: number, submitError: SubmissionError, submitting?: boolean, isValid: boolean, className?: string }) => {
    let lastStep = (props.nrOfSteps == 0 || props.stepIndex == (props.nrOfSteps - 1));
    return (
        <>
            {lastStep && (
                <>
                    {(props.submitError.message && !props.submitError.field) && (
                        <div className="alert alert-danger">{props.submitError.message ?? t("forms.invalid-form")}</div>
                    )}
                    <BrandButton className={`btn btn-cta full-width ${props.className && props.className}`} loading={props.submitting}
                                 type="submit"
                                 onMouseDown={event => event.preventDefault()}
                                 disabled={!props.isValid || !props.allValid}
                    >
                        <span>{t("forms.submit")}</span>
                    </BrandButton>
                </>

            )}
            {!lastStep && (
                <BrandButton className={`btn btn-cta full-width ${props.className && props.className}`} type="submit"
                             onMouseDown={event => event.preventDefault()} disabled={!props.isValid}>
                    <span>{t("forms.next")}</span>
                </BrandButton>
            )}
        </>
    )
}